import React from 'react';
import PropTypes from 'prop-types';

import { kebabCase, isFunction } from 'lodash';
import { FormattedMessage } from 'component-utilities/intl';
import { killEvent } from 'event-helpers';
import displayName from 'component-lib/displayName';

import styles from './Login.scss';

import { LINKS } from './config';

const LOGIN_LINKS = LINKS.reduce((all, link) => ({ ...all, [link.toUpperCase()]: link }), {});

export { LOGIN_LINKS };

export default function LoginFormLinks(props) {
    const onLinkClick = cb => (e) => {
        killEvent(e);

        cb();
    };

    return (
        <div className={styles['login-links']}>
            {LINKS.map((link) => {
                const linkAction = props.links[link];

                if (!linkAction) return null;

                const anchorAction = isFunction(linkAction)
                    ? { onClick: onLinkClick(linkAction), href: '' }
                    : { href: linkAction };

                return (
                    <span key={link} className={styles['login-text']}>
                        {link === LOGIN_LINKS.CONTACT_SUPPORT && (
                            <data>
                                <FormattedMessage id="components.login.need_more_help" />
                &nbsp;
                            </data>
                        )}
                        <a className={styles['text-link']} data-action={kebabCase(link)} {...anchorAction}>
                            <FormattedMessage id={`components.login.${link}`} />
                        </a>
                    </span>
                );
            })}
        </div>
    );
}

LoginFormLinks.displayName = displayName('Login/LoginFormLinks');

LoginFormLinks.propTypes = {
    links: PropTypes.shape({
        forgotYourPassword: PropTypes.func,
        getHelp: PropTypes.func,
    }).isRequired,
};
